
export { Provider } from "/app/shared/services/remote-config/src/config.ts"
export { client } from "./src/client"